<script lang="ts">
  import Hr from '$lib/components/Hr.svelte';
</script>

<slot />
<Hr class="my-8" />
<div class="article leading-7">
  <p>
    uTheory experiments are games and exercises that we're working on polishing before we include
    them in uTheory. There may be bugs, things may be broken, but we like sharing them with the
    world to get feedback!
  </p>
  <p>
    Let us know what you think of these. Drop us a note at
    <a href="mailto:hello@utheory.com" class="a">hello@utheory.com</a>.
  </p>
</div>
